import { BrowserRouter , Routes , Route } from "react-router-dom";
import React from "react";
import Signup from "./signup";
import LoginPage from "./login";
import Chat from "./chat";



function Route1(){
    return (
        <BrowserRouter>
        <Routes>
          <Route path="/" element={<LoginPage/>}/>
            <Route index element={<LoginPage/>}/>
            <Route path="/chat" element={<Chat/>}/>
            <Route path="/signup" element={<Signup/>}/>
            <Route path="/login" element={<LoginPage/>}/>
        </Routes>
      </BrowserRouter>
    )
}

export default Route1;